import {
  ActionCardContainer,
  ActionCardContent,
  ActionCardDescription,
  ActionCardIcon,
  ActionCardTitle,
} from './StoreActionCard.styled'
import { ReactNode } from 'react'
import { css } from '@emotion/react'

export function StoreActionCard({
  'data-testid': dataTestId,
  title,
  description,
  onClick,
  className,
  icon,
  active,
  price,
}: {
  'data-testid'?: string
  title: string
  description: string
  className?: string
  icon?: ReactNode
  price?: ReactNode
  onClick?: () => void
  active?: boolean
}) {
  return (
    <ActionCardContainer
      data-testid={dataTestId}
      onClick={onClick}
      className={className}
      active={active}
    >
      <div
        css={css`
          flex-grow: 1;
          display: flex;
        `}
      >
        <ActionCardIcon active={active}>{icon}</ActionCardIcon>
        <div
          css={css`
            margin: 1.5625rem;
            flex-shrink: 0;
          `}
        >
          {price}
        </div>
      </div>
      <ActionCardContent>
        <ActionCardTitle>{title}</ActionCardTitle>
        <ActionCardDescription>{description}</ActionCardDescription>
      </ActionCardContent>
    </ActionCardContainer>
  )
}
